{
  "filter": {
    "all": "Tous",
    "country": "Pays",
    "direct": "Directs",
    "indirectConfidential": "Indirects & confidentiels",
    "nonConfidential": "Indirects & non-confidentiels"
  },
  "list": {
    "countContact_one": "{{count}} contact",
    "countContact_many": "{{count}} contacts",
    "countContact_other": "{{count}} contacts",
    "noAddress": "Aucune",
    "noSuppliers": "Aucun résultat",
    "searchPlaceholder": "Alias, entreprise, etc.",
    "supplierTypePlaceholder": "Tous"
  },
  "productionSites": {
    "columns": {
      "confidential": "Confidentiel",
      "contactEmail": "Contact (email)",
      "country": "Localisation",
      "internalCode": "Code interne",
      "name": "Nom du site",
      "parentCompany": "Entreprise",
      "performedActivities": "Activités réalisées",
      "registrationId": "Identifiants professionnels du site"
    },
    "filters": {
      "searchPlaceholder": "Rechercher"
    },
    "search": {
      "placeholder": "Rechercher"
    },
    "title": "Sites de production"
  },
  "repository": {
    "actions": {
      "delete": "Supprimer",
      "edit": "Modifier"
    },
    "create": {
      "error": {
        "message": "The business partner has not been created",
        "title": "Error creating business partner"
      },
      "success": {
        "message": "The business partner has been created successfully",
        "title": "Business partner created"
      }
    },
    "delete": {
      "error": {
        "message": "The business partner has not been deleted",
        "title": "Error deleting business partner"
      },
      "success": {
        "message": "The business partner has been deleted successfully",
        "title": "Business partner deleted"
      }
    },
    "title": "Tous",
    "update": {
      "error": {
        "message": "The business partner has not been updated",
        "title": "Error updating business partner"
      },
      "success": {
        "message": "The business partner has been updated successfully",
        "title": "Business partner updated"
      }
    }
  },
  "risk": {
    "high": "Elevé",
    "low": "Faible",
    "medium": "Moyen",
    "table": {
      "certificationRisk": {
        "title": "Risque audit & certification",
        "tooltip": "Évalue le statut de conformité du partenaire basé sur la collecte de certificats et résultats d'audits"
      },
      "collaborationRisk": {
        "title": "Risque collaboration",
        "tooltip": "Évalue le niveau d'engagement du partenaire sur la plateforme (taux de complétion et rapidité des réponses aux demandes de traçabilité)"
      }
    }
  },
  "sort": {
    "averageResponseTime": "Temps moyen de réponse",
    "company": "Entreprise",
    "completedProductionSiterequests": "Requêtes fermées (site de production)",
    "completedProductrequests": "Requêtes fermées (produit)",
    "completedScopeCertificaterequests": "Requêtes fermées (certificat de portée)",
    "completedTransactionCertificaterequests": "Requêtes fermées (certificat de transaction)",
    "email": "Email",
    "lastConnectionDate": "Dernière connexion",
    "lastReminderDate": "Dernière relance",
    "name": "Nom",
    "pendingDocumentrequests": "Requêtes ouvertes (document)",
    "pendingProductionSiterequests": "Requêtes ouvertes (site)",
    "pendingProductrequests": "Requêtes ouvertes (produit)",
    "pendingScopeCertificaterequests": "Requêtes ouvertes (certificat)",
    "pendingTransactionCertificaterequests": "Requêtes ouvertes (transaction)"
  },
  "subSuppliers": {
    "title": "Mes Fournisseurs"
  },
  "supplier": {
    "averageResponseTime": "Temps moyen de réponse",
    "averageResponseTimeValue_one": "{{nbDays}} jour",
    "averageResponseTimeValue_many": "{{nbDays}} jours",
    "averageResponseTimeValue_other": "{{nbDays}} jours",
    "informationRequests": "Requêtes produits",
    "lastConnection": "Dernière connexion",
    "lastConnectionValue": "il y a {{nbDays}} jours",
    "lastReminderSent": "Dernière relance",
    "lastReminderSentValue": "il y a {{nbDays}} jours",
    "noLastConnection": "Aucune",
    "noLastReminderSent": "Aucune",
    "noResponseTime": "Aucune réponse",
    "productionSites": "Sites de production",
    "scopeCertificates": "Certificats et Audits",
    "transactionCertificates": "Preuves de transaction",
    "transferContact_one": "Transférer {{count}} requête de traçabilité.",
    "transferContact_many": "Transférer {{count}} requêtes de traçabilité.",
    "transferContact_other": "Transférer {{count}} requêtes de traçabilité.",
    "transferContactCertificates_one": "Transférer {{count}} requête de certificat.",
    "transferContactCertificates_many": "Transférer {{count}} requêtes de certificat.",
    "transferContactCertificates_other": "Transférer {{count}} requêtes de certificat.",
    "transferModal": {
      "companyCountry": "Pays",
      "companyCountryPlaceholder": "France",
      "companyName": "Entreprise",
      "companyNamePlaceholder": "Trace for good",
      "email": "Contact (email)",
      "emailPlaceholder": "support@traceforgood.com",
      "name": "Alias",
      "namePlaceholder": "Jean Moulin",
      "title": "Transférer les requêtes",
      "transfer": "Transférer",
      "transferSuccess_one": "{{count}} requêtes transmises avec succès",
      "transferSuccess_many": "{{count}} requêtes transmises avec succès",
      "transferSuccess_other": "{{count}} requêtes transmises avec succès"
    }
  },
  "title": "Partenaires commerciaux"
}
